export default function Choice({name, type, checked, value, children, onChange, className}) {
    return (
        <label className={"ein-choice" + (className ? ` ${className}` : '')}>
            {children}
            <input
                type={type || 'radio'}
                name={name}
                checked={checked}
                value={value}
                className={"appearance-none border-none !pl-0"}
                onChange={(e) => onChange && onChange(e.target)}
            />
        </label>
    )
}